import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from "../../Style/MoaStyled";
import { Color } from '../../';
import Box from '@mui/material/Box';
import { MarginProps } from '../../Style/Margin';
import { PaddingProps, hasPaddingProps } from '../../Style/Padding';
var StyleVariant = /** @class */ (function () {
    function StyleVariant() {
    }
    var _a;
    _a = StyleVariant;
    StyleVariant.layout = {
        alignItems: 'flex-start',
        gap: '0.625rem',
    };
    StyleVariant.shadow = __assign(__assign({}, _a.layout), { background: Color.primary.white, boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.14)' });
    StyleVariant.shadow2 = __assign(__assign({}, _a.layout), { backgroundColor: 'var(--color-bg, #ffffff)', display: 'flex', boxShadow: 'var(--elevation-200-canvas, 0px 0px .5px rgba(0, 0, 0, .18), 0px 3px 8px rgba(0, 0, 0, .1), 0px 1px 3px rgba(0, 0, 0, .1))' });
    StyleVariant.strock = __assign(__assign({}, _a.layout), { border: "1px solid ".concat(Color.component.gray_light), background: Color.primary.white });
    return StyleVariant;
}());
var StyledComponent = styled(function (props) {
    var id = props.id, children = props.children, variant = props.variant, width = props.width, height = props.height, flexItem = props.flexItem, backgroundColor = props.backgroundColor, borderRadius = props.borderRadius, border = props.border, relative = props.relative;
    var _sx = {};
    if (variant === 'shadow')
        _sx = StyleVariant.shadow;
    if (variant === 'shadow2')
        _sx = StyleVariant.shadow2;
    if (variant === 'strock')
        _sx = StyleVariant.strock;
    return (_jsx(Box, { id: id, sx: __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({}, _sx), { width: width, height: height, display: flexItem ? 'flex' : 'block', boxSizing: 'border-box' }), MarginProps(props)), (hasPaddingProps(props) ? PaddingProps(props) : { padding: '0.625rem' })), (backgroundColor !== undefined ? { backgroundColor: backgroundColor } : {})), (borderRadius !== undefined ? { borderRadius: borderRadius } : { borderRadius: '0.25rem' })), (border !== undefined ? { border: border } : {})), (relative ? { position: 'relative' } : {})), justifyContent: 'center', children: children }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
